// 创建一个数组用于存储自定义的历史栈
const customHistoryStack = [];
// 保存初始页面 URL
customHistoryStack.push(window.location.href);

// 自定义封装 `history.pushState`，手动管理历史栈
const originalPushState = history.pushState;
history.pushState = function () {
	// 调用原生的 `pushState`
	originalPushState.apply(this, arguments);
	// 手动将新 URL 添加到自定义历史栈中
	customHistoryStack.push(window.location.href);
};

// 自定义封装 `history.replaceState`，手动管理历史栈
const originalReplaceState = history.replaceState;
history.replaceState = function () {
	// 调用原生的 `replaceState`
	originalReplaceState.apply(this, arguments);
	// 替换当前 URL 到自定义历史栈中
	customHistoryStack[customHistoryStack.length - 1] = window.location.href;
};

// 判断上一个浏览地址
export function getPreviousPage() {
	return customHistoryStack.length > 1 ? customHistoryStack[customHistoryStack.length - 2] : null;
}



// WEBPACK FOOTER //
// ./src/js/historyRouter.js